import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { VehicleMobileHomeModel } from '../models/vehicle-mobile-home.model';

@Injectable()
export class VehicleMobileHomeService extends BaseApiService {

    getMobileHomeRelatedVehicles(vehicleId: number): Observable<VehicleMobileHomeModel[]> {
        return this.get('Vehicle/VehicleMobileHome/GetRelatedVehicles/' + vehicleId).pipe(map(r => r.result));
    }

    saveMobileHomeRelatedVehicle(vehicleId: number, relatedVehicleId: number) {
        return this.post(`Vehicle/VehicleMobileHome/${vehicleId}/RelatedVehicle/${relatedVehicleId}`, {});
    }

    deleteMobileHomeRelatedVehicle(vehicleId: number) {
        return this.delete(`Vehicle/VehicleMobileHome/${vehicleId}`);
    }
}
